<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  backgroundColor?: string;
}
const props = withDefaults(defineProps<Props>(), {
  backgroundColor: 'nuts-sky',
});

const bgColor = computed(() => TWColorsBackground[props.backgroundColor] ?? 'bg-nuts-sky-600');
</script>

<script lang="ts">
// eslint-disable-next-line import/first
import { BuilderComponent, TWColorsBackground } from '@/utils/cms';

export const MarqueeBannerRegistration: BuilderComponent = {
  name: 'MarqueeBanner',
  canHaveChildren: true,
  inputs: [
    {
      name: 'backgroundColor',
      type: 'string',
      enum: Object.keys(TWColorsBackground),
      defaultValue: 'nuts-sky',
    },
  ],
};
</script>

<template>
  <div class="flex gap-4 overflow-x-hidden select-none" :class="bgColor" role="marquee">
    <ul class="flex justify-around min-w-full gap-4 py-2 marquee whitespace-nowrap shrink-0">
      <li v-for="item in 10" :key="item" class="flex items-center justify-center gap-4">
        <slot />
      </li>
    </ul>
    <ul
      class="flex justify-around min-w-full gap-4 py-2 marquee whitespace-nowrap shrink-0"
      aria-hidden="true"
    >
      <li v-for="item in 10" :key="item" class="flex items-center justify-center gap-4">
        <slot />
      </li>
    </ul>
  </div>
</template>

<style scoped>
.marquee {
  animation: marquee 150s linear infinite;
}

@keyframes marquee {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(calc(-100% - 1rem));
  }
}
</style>
